export default "__VITE_ASSET__C77WdLF5__"